import { all } from "redux-saga/effects";
import authSaga from "@iso/redux/auth/saga";
import ecommerceSaga from "@iso/redux/ecommerce/saga";
import invoicesSagas from "@iso/redux/invoice/saga";

export default function* rootSaga(getState) {
  yield all([authSaga(), ecommerceSaga(), invoicesSagas()]);
}
